import { useTranslation } from 'react-i18next';

export default function CTAFinal() {
  const { t } = useTranslation('saintnicolas');

  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  return (
    <section className="py-14 md:py-20 bg-copper">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-manrope font-bold text-white mb-3 md:mb-4">
          {t('cta_h2')}
        </h2>
        <p className="text-sm md:text-base text-white/90 mb-8 md:mb-10 max-w-xl mx-auto">
          {t('cta_subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigateTo('/soumission-gratuite')}
            className="inline-flex items-center gap-2 bg-white hover:bg-white/90 text-copper font-semibold px-6 md:px-8 py-3 md:py-4 rounded-md text-sm md:text-base transition-all duration-300 whitespace-nowrap"
          >
            {t('cta_button')}
            <i className="ri-arrow-right-line" />
          </button>

          <a
            href="tel:+14184769950"
            aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
            title="Cliquez pour appeler"
            className="inline-flex items-center gap-2 text-white font-semibold text-sm md:text-base hover:text-white/80 transition-colors whitespace-nowrap"
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20">
              <i className="ri-phone-line" />
            </span>
            {t('cta_phone')}
          </a>
        </div>
      </div>
    </section>
  );
}